/* eslint-disable */
export const baseMixin = {
  mounted() {
    var devicewidth = document.documentElement.clientWidth;
    var scale = devicewidth / 750;
    document.body.style.zoom = scale;
  },
};
